export default __webpack_public_path__ + "static/media/IMG_9430.60019aab.jpeg";